






































































































































import { Component, Vue } from "vue-property-decorator";
import { GeneralService } from "../services/general-service";
import config from "../services/api-config";
import router from "../router";
import store from "../store";
import AuthService from "../services/auth-service";
import StarRating from "vue-star-rating";
import "../styles/Videos.scss";
import moment from "moment";
import * as franc from "franc";
import { swiper, swiperSlide } from "vue-awesome-swiper";

declare var amp: any;
declare var AppInsightsUtils: any;
declare const InstallTrigger: any;
declare const window: any;

@Component({
  components: {
    "star-rating": StarRating,
    swiper,
    swiperSlide,
  },
  props: [
    "topicid",
    "topiclimit",
    "topics",
    "topic",
    "chapters",
    "chaptername",
  ],
})
export default class VideoLearningSmart extends Vue {
  private service = new GeneralService();
  private level_id;
  private auth = new AuthService();
  starSize: number = 20;
  private topiclimit: number;
  private ifQuestionExists = false;
  private teacherID = "";
  private subjectID = "";
  private totalTime = 0;
  private prevStartTime = 0;
  private lastUpdatedTime = 0;
  private ended = false;
  private maxWatched = 0;
  private ratingPrevId = "";
  private isSmart = false;
  private topics: any;
  private topic: any;
  private chapters: any;
  private chaptername: any;

  private startError = false;
  private errorMessageVideo = "";
  private lastTime = 0;

  private showTime() {
    this.prevStartTime = this.player.currentAbsoluteTime();
  }

  private pauseTime() {
    this.totalTime +=
      this.player.player_.mediaPlayer.currentAbsoluteTime - this.prevStartTime;
  }

  private progressClicked() {
    this.lastUpdatedTime = this.player.player_.mediaPlayer.currentAbsoluteTime;
  }

  private videoCompleted() {
    this.ended = true;
  }

  private slidePrev(x) {
    (this.$refs[x] as any)[0].swiper.slidePrev()
  }

  private slideNext(x) {
    (this.$refs[x] as any)[0].swiper.slideNext()
  }

  private checkLang(str) {
    var lst = ["und", "urd", "fas", "pes", "skr", "arb", "uig"];
    var lan = franc(str, { minLength: 3 });

    return lst.indexOf(lan) > -1;
  }

  private seekingTime(event) {
    this.maxWatched = Math.max(
      this.maxWatched,
      this.player.currentAbsoluteTime()
    );
  }

  private seekedTime() {
    this.totaltime += this.lastUpdatedTime - this.prevStartTime;
  }

  private items = [
    {
      text: "Subjects",
      to: { name: "videosubject" },
    },
    {
      text: this.$store.state.selectSubjectName,
      href: "#",
    },
    {
      text: this.$store.state.selectSubjectName,
      href: "#",
    },
    {
      text: "Library",
      active: true,
    },
  ];

  private sourceLoaded = false;

  private entities: any = [];
  private entity: any;

  private question = "";
  private currentTopicId = "";
  private totaltime: number = 0;
  private previous: number = 0;
  private previousW: number = 0;
  private duration: number = 0;
  private actualW: number = 0;
  private srcToken: any;

  private firstTimeVideo = true;

  private ratingPrev = 0;

  private classSection = "";

  private parts: Array<Parts> = [];

  private chankParts: Array<Chank> = [];
  private totalChanks: number = 20;
  private chankStarted: boolean = false;

  private VsId: string = "";

  private rating: number = 0;
  private source: string = "";

  topicid: string;
  private player: any;

  private followUp = "";

  private timeInterval;
  private firstTime: boolean = true;

  private iframeHtml = '';

  private teacherData: any = [];
  private swiperOption = {
    slidesPerView: 2,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    keyboard: {
      enabled: true,
    },
    breakpoints: {
      // when window width is <= 640px
      640: {
        slidesPerView: 1,
      },
      1000: {
        slidesPerView: 2,
      },
    },
  };

  created() {
    this.level_id = localStorage[config.classLevl];
    this.VsId = localStorage["VsId"];

    if (
      this.level_id == "" ||
      this.level_id == undefined ||
      this.level_id == "null"
    ) {
      router.push("select");
    }

    if (this.$route.query.type && this.$route.query.type == "smart") {
      this.isSmart = true;
    }

    this.entities = this.topics;
    this.entity = this.topic;

    if (this.entities !== undefined) {
      if (this.entities.length > 0) {
        this.current(this.entity.TopicId);
        this.actualW = 0;
        this.duration = 0;
      }
    }
  }

  mounted() {
    AppInsightsUtils.setAuthNUserContext(
      this.auth.isAuthenticated(),
      this.auth.session.userName.split("@")[0]
    );

    this.service
      .getTeacherSubject(
        this.auth.session.userName.split("@")[0],
        localStorage[config.deviceId]
      )
      .then((result) => {
        this.teacherData = result.data.Data;

        for (const teacher of this.teacherData) {
          if (teacher.subject_Name == this.$store.state.selectSubjectName) {
            this.ifQuestionExists = true;
            this.teacherID = teacher.teacher_ID;
            this.subjectID = teacher.subject_ID;
          }
        }
      });

    this.service
      .getInfoEMS(this.auth.session.userName.split("@")[0])
      .then((result) => {
        this.classSection = result.data[0].Class_section_id;
      });

  }


  private goingAway(action: string) {
    this.$emit("reset", action);
  }

  private checkBrowser(src, calback) {
    let brow = "widevine";
    if (this.$browserDetect.isEdge || this.$browserDetect.isIE) {
      brow = "playReady";
    }
    if (this.$browserDetect.isSafari) {
      brow = "clear";
    }
    this.getToken(src, brow, (data) => {
      calback(data);
    });
  }

  private getToken(source, brow, callback) {
    this.service
      .getVideoToken(source, brow)
      .then((result) => {
        this.srcToken = result;
        callback(result);

        this.player.src([
          {
            src: result.src, //response.src,
            type: "application/vnd.ms-sstr+xml", //response.type,
            protectionInfo: [
              {
                type: result.protectionInfo.type,
                certificateUrl: result.protectionInfo.certificateUrl,
                authenticationToken: result.protectionInfo.authenticationToken,
              },
            ],
          },
        ]);
      })
      .catch((err) => {
        console.error(`Error: ${err.message}`);
      });
  }

  private current(id) {
    this.ratingPrev = 0;
    this.ratingPrevId = this.currentTopicId;

    this.sourceLoaded = false;


    if (this.player) {
      this.player.pause();
    }

    this.maxWatched = 0;
    this.currentTopicId = id;
    const entity = this.entities.find((e) => e.TopicId === id);
    // const entity = {
    //   videoLink: topic.VideoLink,
    //   fullName: topic.FullName,
    //   topicId: id,
    // };
    if (entity !== undefined) {
      this.source = entity.VideoLink;
      this.$store.state.topicSelectName = entity.FullName;
      this.entity = entity;
      this.duration = 26;


      if (entity.VideoLink.indexOf('<iframe') != -1) {
        this.iframeHtml = entity.VideoLink;
        this.sourceLoaded = true;
      }
      else {
        this.iframeHtml = '';


        this.checkBrowser(entity.VideoLink, (data) => {
          this.loadVideo();
        });

      }

      this.chankStarted = false;
      this.actualW = 0;
      this.duration = 0;
    }
  }

  private ampEventHandler(evt) {
    AppInsightsUtils.ampEventHandler4AppInsights(
      evt,
      this.player,
      this.$store.state.topicSelectName
    );
  }

  private registerEvents(amPlayer, ampEventHandler) {
    var events = [
      amp.eventName.loadstart,

      amp.eventName.durationchange,

      amp.eventName.loadeddata,

      amp.eventName.loadedmetadata,

      amp.eventName.canplaythrough,

      amp.eventName.waiting,

      amp.eventName.play,

      amp.eventName.playing,

      amp.eventName.ended,

      amp.eventName.seeking,

      amp.eventName.seeked,

      amp.eventName.pause,

      amp.eventName.fullscreenchange,

      amp.eventName.volumechange,

      amp.eventName.error,

      amp.eventName.timeupdate,

      amp.eventName.playbackbitratechanged,

      amp.eventName.downloadbitratechanged,
    ];
    for (let i = 0; i < events.length; i++) {
      this.player.addEventListener(events[i], ampEventHandler);
    }
  }

  private loadVideo() {
    let client = document.getElementById("main-content");
    if (client !== null) {
      this.player = amp("azuremediaplayer", {
        nativeControlsForTouch: false,
        logo: { enabled: false },
        autoplay: false,
        fluid: true,
        playbackSpeed: {
          enabled: true,
          initialSpeed: 1.0,
          speedLevels: [
            { name: "x4.0", value: 4.0 },
            { name: "x3.0", value: 3.0 },
            { name: "x2.0", value: 2.0 },
            { name: "x1.75", value: 1.75 },
            { name: "x1.5", value: 1.5 },
            { name: "x1.25", value: 1.25 },
            { name: "normal", value: 1.0 },
            { name: "x0.75", value: 0.75 },
            { name: "x0.5", value: 0.5 },
          ],
        },
        controls: true,
        width: "auto",
        height: 600,
        techOrder: [
          "azureHtml5JS",
          "flashSS",
          "html5FairPlayHLS",
          "silverlightSS",
          "html5",
        ],
      });
      //   this.player.addEventListener(amp.eventName.play, this.showTime);
      // this.player.addEventListener(amp.eventName.pause, this.pauseTime);
      this.player.addEventListener(amp.eventName.seeked, this.seekingTime);
      // this.player.addEventListener(amp.eventName.seeked, this.seekedTime);
      // let controlelement = document.getElementsByClassName('vjs-progress-control')[0];
      // controlelement.addEventListener("mouseover", this.progressClicked);

      this.player.addEventListener(amp.eventName.ended, this.videoCompleted);

      this.registerEvents(this.player, this.ampEventHandler);
    }
    // this.player.src([
    //   { type: "application/vnd.ms-sstr+xml", src: this.source },
    // ]);
    this.player.src([
      {
        src: this.srcToken.src, //response.src,
        type: this.srcToken.Type, //response.type,
        protectionInfo: [
          {
            type: this.srcToken.protectionInfo.type,
            certificateUrl: this.srcToken.protectionInfo.certificateUrl,
            authenticationToken:
              this.srcToken.protectionInfo.authenticationToken,
          },
        ],
      },
    ]);

    this.player.addEventListener("error", this.errorPlayback);

    clearInterval(this.timeInterval);
    this.totaltime = 0;
    this.timeInterval = setInterval(() => {
      if (this.totaltime == 0) {
        this.totaltime = Math.round(this.player.duration());

        if (this.totaltime > 0) {
          this.resetTimer(this.totaltime);
        }
      }

      if (this.totaltime > 0) {
        this.chunkTimer(this.player.currentTime());
      }
    }, 1000);

    this.sourceLoaded = true;
  }

  errorPlayback() {
    this.errorMessageVideo =
      "There was an issue in your playback, kindly check your internet connection. We will reload the video so you can seamlessly view it again.";

    this.lastTime = this.player.currentTime();
    this.startError = true;

    this.player.src([
      { type: "application/vnd.ms-sstr+xml", src: this.srcToken.src },
    ]);
  }

  private createChunks() {
    if (this.chankStarted == false && this.totaltime > 0) {
      this.chankParts = [];
      this.chankStarted = true;
      var oneChank = this.totaltime / this.totalChanks;

      for (var i = 0; i < this.totalChanks; i++) {
        this.chankParts.push({
          start: Math.round(oneChank * (i + 1) - oneChank),
          end: Math.round(oneChank * (i + 1)),
          watched: 0,
        });
      }

      this.chankStarted = true;
    }
  }

  private resetTimer(videoTime) {
    this.totaltime = Math.round(videoTime);

    if (this.chankStarted == false && this.totaltime > 0) {
      this.chankParts = [];
      this.chankStarted = true;
      var oneChank = this.totaltime / this.totalChanks;

      for (var i = 0; i < this.totalChanks; i++) {
        this.chankParts.push({
          start: Math.round(oneChank * (i + 1) - oneChank),
          end: Math.round(oneChank * (i + 1)),
          watched: 0,
        });
      }

      this.chankStarted = true;
    }
  }

  private prevTopic() {
    if (this.entities.indexOf(this.entity) > 0) {
      if (
        this.entities[this.entities.indexOf(this.entity) - 1].orderNumber === 0
      ) {
        this.paidMessage();
      } else {
        this.saveWatched();
        this.entity = this.entities[this.entities.indexOf(this.entity) - 1];
      }
    }
  }

  private nextTopic() {
    if (this.entities.indexOf(this.entity) < this.entities.length - 1) {
      if (
        this.entities[this.entities.indexOf(this.entity) + 1].orderNumber === 0
      ) {
        this.paidMessage();
      } else {
        this.saveWatched();
        this.entity = this.entities[this.entities.indexOf(this.entity) + 1];
      }
    }
  }

  private paidMessage() {
    // this.dialog.show<PayComponent>(PLATFORM.moduleName('app/backend/pay.component'));
  }

  private sumActual() {
    var realW = 0;
    for (var i = 0; i < this.parts.length; i++) {
      if (this.parts[i].vieved === true && this.parts[i].percentage > 0) {
        realW += this.parts[i].percentage;
      }
    }

    return realW;
  }

  private chunkTimer(timeToken) {
    this.duration = Math.round((Math.round(timeToken) * 100) / this.totaltime);
    this.actualW = timeToken;

    if (this.chankParts.length > 0) {
      var watche = 0;
      for (var i = 0; i < this.totalChanks; i++) {
        var start = this.chankParts[i].start;
        var end = this.chankParts[i].end;

        if (this.actualW >= start && this.actualW <= end) {
          var watchedChunk = timeToken - this.chankParts[i].start;
          this.chankParts[i].watched =
            Math.round((watchedChunk * 100) / this.chankParts[i].end) > 50
              ? 100
              : Math.round((watchedChunk * 100) / this.chankParts[i].end);
        }
        watche += this.chankParts[i].watched;
      }
      this.duration = Math.round(
        (watche / (this.chankParts.length * 100)) * 100
      );
    } else {
      this.createChunks();
    }
  }

  private saveWatched() {
    var topicsWatched: TopicsWatched = {
      topicWatchId: config.createGuid(),
      userId: this.auth.session.userId,
      topicId: this.entity.topicId,
      operationOn: new Date(Date.now()),
      enableMcq: false,
      duration: this.actualW,
      percentage: this.duration >= 25 ? 100 : this.duration,
    };

    this.service.insertTopicWached(topicsWatched).catch((err) => {
      console.error(`Error: ${err.message}`);
    });
  }

  private askQuestion() {
    this.service.askQuestion(
      this.auth.session.userName.split("@")[0],
      this.teacherID,
      this.subjectID,
      this.question,
      this.classSection
    );
  }

  beforeDestroy() {
    this.player.dispose();
    clearInterval(this.timeInterval);
    this.saveWatched();
  }
}

interface Parts {
  percentage: number;
  vieved: boolean;
  css: string;
}

interface Chank {
  start: number;
  end: number;
  watched: number;
}
